import * as React from 'react';

function SvgMessengerMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.449 23.764C4.736 21.727 3 18.608 3 15.11 3 8.975 8.345 4 14.938 4c6.592 0 11.937 4.975 11.937 11.111 0 6.137-5.345 11.111-11.938 11.111-1.19 0-2.339-.163-3.424-.464L7.45 28v-4.236zm5.635-8.06l3.04 3.259L22.649 12l-5.858 3.26L13.677 12l-6.525 6.963 5.932-3.26z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMessengerMono;
